/**
 * Service Worker utilities
 */

export const isServiceWorkerSupported = (): boolean => {
  return typeof window !== "undefined" && "serviceWorker" in navigator;
};

export const registerServiceWorker = async () => {
  if (!isServiceWorkerSupported()) return null;

  try {
    const registration = await navigator.serviceWorker.register(
      "/service-worker.js",
      { scope: "/" },
    );

    // Wait for the service worker to be ready
    await navigator.serviceWorker.ready;

    return registration;
  } catch (error) {
    return null;
  }
};

export const unregisterServiceWorker = async () => {
  if (!isServiceWorkerSupported()) return false;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();

    for (const registration of registrations) {
      await registration.unregister();
    }

    return true;
  } catch {
    return false;
  }
};

export const getServiceWorkerRegistration = async () => {
  if (!isServiceWorkerSupported()) return null;

  try {
    return await navigator.serviceWorker.ready;
  } catch (error) {
    return null;
  }
};

export const isPushNotificationSupported = (): boolean => {
  return (
    isServiceWorkerSupported() &&
    "PushManager" in window &&
    "Notification" in window
  );
};

export const getPushSubscription = async () => {
  const registration = await getServiceWorkerRegistration();

  if (!registration) return null;

  try {
    return await registration.pushManager.getSubscription();
  } catch (error) {
    return null;
  }
};
